import eventBus from '@/event/event';

const MODAL_DATA_KEY = 'sixEight618ModalData';
const PAID_DATE_KEY = 'sixEight618PaidDate';
export const SIX_EIGHT_618_PAID_EVENT = 'sixEight618Paid';

export type SixEight618ModalData = {
  date: string;
  count: number;
  lastShown: number;
};

const getToday = () => new Date().toDateString();

export const getSixEight618ModalData = (): SixEight618ModalData => {
  try {
    const raw = localStorage.getItem(MODAL_DATA_KEY);
    if (raw) {
      return JSON.parse(raw);
    }
  } catch {
    // ignore
  }
  return { date: '', count: 0, lastShown: 0 };
};

export const isSixEight618PaidToday = (): boolean => {
  return localStorage.getItem(PAID_DATE_KEY) === getToday();
};

export const markSixEight618PaymentCompleted = (): void => {
  localStorage.setItem(PAID_DATE_KEY, getToday());
  eventBus.emit(SIX_EIGHT_618_PAID_EVENT);
};

export const saveSixEight618ModalOnClose = (): void => {
  const today = getToday();
  const now = Date.now();
  const modalData = getSixEight618ModalData();
  const newData: SixEight618ModalData = {
    date: today,
    count: (modalData.date === today ? modalData.count : 0) + 1,
    lastShown: now,
  };
  localStorage.setItem(MODAL_DATA_KEY, JSON.stringify(newData));
};

export const shouldShowSixEight618Modal = (): boolean => {
  if (isSixEight618PaidToday()) {
    return false;
  }

  const today = getToday();
  const now = Date.now();
  const modalData = getSixEight618ModalData();

  if (modalData.date !== today) {
    localStorage.setItem(
      MODAL_DATA_KEY,
      JSON.stringify({ date: today, count: 0, lastShown: 0 }),
    );
    return true;
  }

  const hoursSinceLastShown =
    (now - (modalData.lastShown || 0)) / (1000 * 60 * 60);
  return modalData.count < 3 && hoursSinceLastShown >= 2;
};
